import {useEffect, useRef, useState} from 'react';

export function useMinimumVisible(visible: boolean, minDuration = 600) {
  const [show, setShow] = useState(false);
  const startTimeRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (visible) {
      startTimeRef.current = Date.now();
      setShow(true);
      return;
    }

    const elapsed = Date.now() - startTimeRef.current;
    const rest = Math.max(minDuration - elapsed, 0);

    timerRef.current = setTimeout(() => {
      setShow(false);
      timerRef.current = null;
    }, rest);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [visible, minDuration]);

  return show;
}